export enum ChannelDetailMode {
  Preview,
  Edit,
}
